import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "Products", href: "#products" },
  { label: "Channels", href: "#channels" },
  { label: "Certifications", href: "#certifications" },
  { label: "Logistics", href: "#logistics" },
  { label: "About", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur border-b border-cream-dark" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Wordmark */}
          <a href="#top" className="flex flex-col leading-none">
            <img
              src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/daebf532-1348-4fa6-9cac-29695844ea0b_compressed_logo-mesa-baja.webp"
              alt="Mesa Baja logo"
              className={`h-7 md:h-9 w-auto object-contain transition-[filter] duration-300 ${
                scrolled ? "logo-orange" : "brightness-0 invert"
              }`}
            />
            <span
              className={`text-[11px] md:text-xs mt-1 ${
                scrolled ? "text-brown" : "text-cream"
              }`}
            >
              Organic cane sugar &amp; cocoa · Colombia
            </span>
          </a>

          {/* Centre nav */}
          <nav className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`whitespace-nowrap text-sm font-medium transition-colors ${
                  scrolled
                    ? "text-ink/80 hover:text-brand"
                    : "text-cream/90 hover:text-white"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Right actions */}
          <div className="flex items-center gap-2">
            <a
              href="#quote"
              className="hidden sm:inline-flex whitespace-nowrap items-center justify-center px-4 py-2.5 rounded-md bg-brand text-white text-sm font-semibold hover:bg-brand-dark transition-colors"
            >
              Request a wholesale quote
            </a>
            {/* Mobile hamburger */}
            <button
              type="button"
              aria-label="Open menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
                scrolled ? "text-ink" : "text-white"
              }`}
            >
              <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-cream-dark shadow-sm">
          <nav className="flex flex-col px-4 py-3">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-ink text-base font-medium border-b border-cream-dark/60 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setMenuOpen(false)}
              className="mt-3 mb-2 inline-flex items-center justify-center px-4 py-3 rounded-md bg-brand text-white text-sm font-semibold hover:bg-brand-dark transition-colors"
            >
              Request a wholesale quote
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}